import React from 'react';
import { DabaduProgressBars } from 'sharedComponents/linearProgress';
import { TradeinHeaderProps } from '../TradeInInterface';

const TradeinHeader: React.FC<TradeinHeaderProps> = ({ title, currentStep = 0, stepConfig }) => {
  const totalSteps = stepConfig?.length ?? 0;

  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className='form-group'>
      <label className='control-label'>{title}</label>
      <DabaduProgressBars value={progress} />
    </div>
  );
};

export default TradeinHeader;
